import React from 'react';
import PropTypes from 'prop-types';
import './chooseOneFlavorTile.scss';
export default function ChooseOneFlavorTile(_ref) {
  var _productVariant$metaf;

  var productVariant = _ref.productVariant,
      onSelected = _ref.onSelected,
      _ref$fallbackImage = _ref.fallbackImage,
      fallbackImage = _ref$fallbackImage === void 0 ? null : _ref$fallbackImage;
  var _productVariant$featu = productVariant.featured_image_thumbnail;
  _productVariant$featu = _productVariant$featu === void 0 ? {} : _productVariant$featu;
  var _productVariant$featu2 = _productVariant$featu.src,
      imgSrc = _productVariant$featu2 === void 0 ? fallbackImage : _productVariant$featu2;

  function handleSelection() {
    onSelected(productVariant);
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      handleSelection();
    }
  } // Sold out tile


  if (productVariant !== null && productVariant !== void 0 && (_productVariant$metaf = productVariant.metafields) !== null && _productVariant$metaf !== void 0 && _productVariant$metaf.soldOut) {
    return /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__flavorContainer--chooseOne"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__selectButton disable",
      role: "button",
      "aria-label": productVariant.title,
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
      alt: "",
      className: "btFlavorSelector__flavorThumbnail btFlavorSelector__flavorThumbnail--opaque_img",
      src: imgSrc
    })), /*#__PURE__*/React.createElement("div", {
      className: "btFlavorSelector__flavorTitle"
    }, /*#__PURE__*/React.createElement("h4", null, productVariant.title, /*#__PURE__*/React.createElement("span", {
      className: "soldOutText"
    }, /*#__PURE__*/React.createElement("br", null), "Sold out")))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__flavorContainer--chooseOne"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__selectButton",
    role: "button",
    "aria-label": productVariant.title,
    tabIndex: 0,
    onClick: handleSelection,
    onKeyPress: handleKeyPress
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: "btFlavorSelector__flavorThumbnail",
    src: imgSrc
  })), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__flavorTitle"
  }, /*#__PURE__*/React.createElement("h4", null, productVariant.title))));
}
ChooseOneFlavorTile.propTypes = {
  productVariant: PropTypes.object.isRequired,
  onSelected: PropTypes.func.isRequired,
  fallbackImage: PropTypes.string
};